interface Details {
    GPU: number;
    CPU: number;
    Memory: number;
    GPUM: number;
}

export interface InstanceType {
    id: string;
    value: string;
    label: string;
    details: Details;
    deprecated?: boolean;
}

export interface TypeGroup {
    label: string;
    options: InstanceType[];
}

export interface InstanceTypes {
    type_groups: TypeGroup[];
}

const opt = (name: string, details: Details, deprecated?: boolean): InstanceType => ({
    id: name,
    value: name,
    label: name,
    details,
    ...(deprecated && { deprecated }),
});

export const instanceTypes: InstanceTypes = {
    type_groups: [
        {
            label: "General Purpose",
            options: [
                opt("ml.t3.medium",   {GPU:0, CPU:2,   Memory:4,    GPUM:0}),
                opt("ml.t3.large",    {GPU:0, CPU:2,   Memory:8,    GPUM:0}),
                opt("ml.t3.xlarge",   {GPU:0, CPU:4,   Memory:16,   GPUM:0}),
                opt("ml.t3.2xlarge",  {GPU:0, CPU:4,   Memory:32,   GPUM:0}),
                opt("ml.t2.medium",   {GPU:0, CPU:2,   Memory:4,    GPUM:0}),
                opt("ml.t2.large",    {GPU:0, CPU:2,   Memory:8,    GPUM:0}),
                opt("ml.t2.xlarge",   {GPU:0, CPU:4,   Memory:16,   GPUM:0}),
                opt("ml.t2.2xlarge",  {GPU:0, CPU:8,   Memory:32,   GPUM:0}),
                opt("ml.m7i.large",   {GPU:0, CPU:2,   Memory:8,    GPUM:0}),
                opt("ml.m7i.xlarge",  {GPU:0, CPU:4,   Memory:16,   GPUM:0}),
                opt("ml.m7i.2xlarge", {GPU:0, CPU:8,   Memory:32,   GPUM:0}),
                opt("ml.m7i.4xlarge", {GPU:0, CPU:16,  Memory:64,   GPUM:0}),
                opt("ml.m7i.8xlarge", {GPU:0, CPU:32,  Memory:128,  GPUM:0}),
                opt("ml.m7i.12xlarge",{GPU:0, CPU:48,  Memory:192,  GPUM:0}),
                opt("ml.m7i.16xlarge",{GPU:0, CPU:64,  Memory:256,  GPUM:0}),
                opt("ml.m7i.24xlarge",{GPU:0, CPU:96,  Memory:384,  GPUM:0}),
                opt("ml.m7i.48xlarge",{GPU:0, CPU:192, Memory:768,  GPUM:0}),
                opt("ml.m6i.large",   {GPU:0, CPU:2,   Memory:8,    GPUM:0}),
                opt("ml.m6i.xlarge",  {GPU:0, CPU:4,   Memory:16,   GPUM:0}),
                opt("ml.m6i.2xlarge", {GPU:0, CPU:8,   Memory:32,   GPUM:0}),
                opt("ml.m6i.4xlarge", {GPU:0, CPU:16,  Memory:64,   GPUM:0}),
                opt("ml.m6i.8xlarge", {GPU:0, CPU:32,  Memory:128,  GPUM:0}),
                opt("ml.m6i.12xlarge",{GPU:0, CPU:48,  Memory:192,  GPUM:0}),
                opt("ml.m6i.16xlarge",{GPU:0, CPU:64,  Memory:256,  GPUM:0}),
                opt("ml.m6i.24xlarge",{GPU:0, CPU:96,  Memory:384,  GPUM:0}),
                opt("ml.m6id.large",  {GPU:0, CPU:2,   Memory:8,    GPUM:0}),
                opt("ml.m6id.xlarge", {GPU:0, CPU:4,   Memory:16,   GPUM:0}),
                opt("ml.m6id.2xlarge",{GPU:0, CPU:8,   Memory:32,   GPUM:0}),
                opt("ml.m6id.4xlarge",{GPU:0, CPU:16,  Memory:64,   GPUM:0}),
                opt("ml.m6id.8xlarge",{GPU:0, CPU:32,  Memory:128,  GPUM:0}),
                opt("ml.m6id.12xlarge",{GPU:0, CPU:48, Memory:192,  GPUM:0}),
                opt("ml.m6id.16xlarge",{GPU:0, CPU:64, Memory:256,  GPUM:0}),
                opt("ml.m6id.24xlarge",{GPU:0, CPU:96, Memory:384,  GPUM:0}),
                opt("ml.m6id.32xlarge",{GPU:0, CPU:128,Memory:512,  GPUM:0}),
                opt("ml.m5.xlarge",   {GPU:0, CPU:4,   Memory:16,   GPUM:0}),
                opt("ml.m5.2xlarge",  {GPU:0, CPU:8,   Memory:32,   GPUM:0}),
                opt("ml.m5.4xlarge",  {GPU:0, CPU:16,  Memory:64,   GPUM:0}),
                opt("ml.m5.12xlarge", {GPU:0, CPU:48,  Memory:192,  GPUM:0}),
                opt("ml.m5.24xlarge", {GPU:0, CPU:96,  Memory:384,  GPUM:0}),
                opt("ml.m5d.large",   {GPU:0, CPU:2,   Memory:8,    GPUM:0}),
                opt("ml.m5d.xlarge",  {GPU:0, CPU:4,   Memory:16,   GPUM:0}),
                opt("ml.m5d.2xlarge", {GPU:0, CPU:8,   Memory:32,   GPUM:0}),
                opt("ml.m5d.4xlarge", {GPU:0, CPU:16,  Memory:64,   GPUM:0}),
                opt("ml.m5d.8xlarge", {GPU:0, CPU:32,  Memory:128,  GPUM:0}),
                opt("ml.m5d.12xlarge",{GPU:0, CPU:48,  Memory:192,  GPUM:0}),
                opt("ml.m5d.16xlarge",{GPU:0, CPU:64,  Memory:256,  GPUM:0}),
                opt("ml.m5d.24xlarge",{GPU:0, CPU:96,  Memory:384,  GPUM:0}),
                opt("ml.m4.xlarge",   {GPU:0, CPU:4,   Memory:16,   GPUM:0}),
                opt("ml.m4.2xlarge",  {GPU:0, CPU:8,   Memory:32,   GPUM:0}),
                opt("ml.m4.4xlarge",  {GPU:0, CPU:16,  Memory:64,   GPUM:0}),
                opt("ml.m4.10xlarge", {GPU:0, CPU:40,  Memory:160,  GPUM:0}),
                opt("ml.m4.16xlarge", {GPU:0, CPU:64,  Memory:256,  GPUM:0}),
            ]
        },
        {
            label: "Compute Optimized",
            options: [
                opt("ml.c7i.large",   {GPU:0, CPU:2,   Memory:4,    GPUM:0}),
                opt("ml.c7i.xlarge",  {GPU:0, CPU:4,   Memory:8,    GPUM:0}),
                opt("ml.c7i.2xlarge", {GPU:0, CPU:8,   Memory:16,   GPUM:0}),
                opt("ml.c7i.4xlarge", {GPU:0, CPU:16,  Memory:32,   GPUM:0}),
                opt("ml.c7i.8xlarge", {GPU:0, CPU:32,  Memory:64,   GPUM:0}),
                opt("ml.c7i.12xlarge",{GPU:0, CPU:48,  Memory:96,   GPUM:0}),
                opt("ml.c7i.16xlarge",{GPU:0, CPU:64,  Memory:128,  GPUM:0}),
                opt("ml.c7i.24xlarge",{GPU:0, CPU:96,  Memory:192,  GPUM:0}),
                opt("ml.c7i.48xlarge",{GPU:0, CPU:192, Memory:384,  GPUM:0}),
                opt("ml.c6i.large",   {GPU:0, CPU:2,   Memory:4,    GPUM:0}),
                opt("ml.c6i.xlarge",  {GPU:0, CPU:4,   Memory:8,    GPUM:0}),
                opt("ml.c6i.2xlarge", {GPU:0, CPU:8,   Memory:16,   GPUM:0}),
                opt("ml.c6i.4xlarge", {GPU:0, CPU:16,  Memory:32,   GPUM:0}),
                opt("ml.c6i.8xlarge", {GPU:0, CPU:32,  Memory:64,   GPUM:0}),
                opt("ml.c6i.12xlarge",{GPU:0, CPU:48,  Memory:96,   GPUM:0}),
                opt("ml.c6i.16xlarge",{GPU:0, CPU:64,  Memory:128,  GPUM:0}),
                opt("ml.c6i.24xlarge",{GPU:0, CPU:96,  Memory:192,  GPUM:0}),
                opt("ml.c6i.32xlarge",{GPU:0, CPU:128, Memory:256,  GPUM:0}),
                opt("ml.c5.xlarge",   {GPU:0, CPU:4,   Memory:8,    GPUM:0}),
                opt("ml.c5.2xlarge",  {GPU:0, CPU:8,   Memory:16,   GPUM:0}),
                opt("ml.c5.4xlarge",  {GPU:0, CPU:16,  Memory:32,   GPUM:0}),
                opt("ml.c5.9xlarge",  {GPU:0, CPU:36,  Memory:72,   GPUM:0}),
                opt("ml.c5.18xlarge", {GPU:0, CPU:72,  Memory:144,  GPUM:0}),
                opt("ml.c5d.xlarge",  {GPU:0, CPU:4,   Memory:8,    GPUM:0}),
                opt("ml.c5d.2xlarge", {GPU:0, CPU:8,   Memory:16,   GPUM:0}),
                opt("ml.c5d.4xlarge", {GPU:0, CPU:16,  Memory:32,   GPUM:0}),
                opt("ml.c5d.9xlarge", {GPU:0, CPU:36,  Memory:72,   GPUM:0}),
                opt("ml.c5d.18xlarge",{GPU:0, CPU:72,  Memory:144,  GPUM:0}),
                opt("ml.c4.xlarge",   {GPU:0, CPU:4,   Memory:7.5,  GPUM:0}),
                opt("ml.c4.2xlarge",  {GPU:0, CPU:8,   Memory:15,   GPUM:0}),
                opt("ml.c4.4xlarge",  {GPU:0, CPU:16,  Memory:30,   GPUM:0}),
                opt("ml.c4.8xlarge",  {GPU:0, CPU:36,  Memory:60,   GPUM:0}),
            ]
        },
        {
            label: "Memory Optimized",
            options: [
                opt("ml.r7i.large",   {GPU:0, CPU:2,   Memory:16,   GPUM:0}),
                opt("ml.r7i.xlarge",  {GPU:0, CPU:4,   Memory:32,   GPUM:0}),
                opt("ml.r7i.2xlarge", {GPU:0, CPU:8,   Memory:64,   GPUM:0}),
                opt("ml.r7i.4xlarge", {GPU:0, CPU:16,  Memory:128,  GPUM:0}),
                opt("ml.r7i.8xlarge", {GPU:0, CPU:32,  Memory:256,  GPUM:0}),
                opt("ml.r7i.12xlarge",{GPU:0, CPU:48,  Memory:384,  GPUM:0}),
                opt("ml.r7i.16xlarge",{GPU:0, CPU:64,  Memory:512,  GPUM:0}),
                opt("ml.r7i.24xlarge",{GPU:0, CPU:96,  Memory:768,  GPUM:0}),
                opt("ml.r7i.48xlarge",{GPU:0, CPU:192, Memory:1536, GPUM:0}),
                opt("ml.r6i.large",   {GPU:0, CPU:2,   Memory:16,   GPUM:0}),
                opt("ml.r6i.xlarge",  {GPU:0, CPU:4,   Memory:32,   GPUM:0}),
                opt("ml.r6i.2xlarge", {GPU:0, CPU:8,   Memory:64,   GPUM:0}),
                opt("ml.r6i.4xlarge", {GPU:0, CPU:16,  Memory:128,  GPUM:0}),
                opt("ml.r6i.8xlarge", {GPU:0, CPU:32,  Memory:256,  GPUM:0}),
                opt("ml.r6i.12xlarge",{GPU:0, CPU:48,  Memory:384,  GPUM:0}),
                opt("ml.r6i.16xlarge",{GPU:0, CPU:64,  Memory:512,  GPUM:0}),
                opt("ml.r6i.24xlarge",{GPU:0, CPU:96,  Memory:768,  GPUM:0}),
                opt("ml.r6i.32xlarge",{GPU:0, CPU:128, Memory:1024, GPUM:0}),
                opt("ml.r6id.large",  {GPU:0, CPU:2,   Memory:16,   GPUM:0}),
                opt("ml.r6id.xlarge", {GPU:0, CPU:4,   Memory:32,   GPUM:0}),
                opt("ml.r6id.2xlarge",{GPU:0, CPU:8,   Memory:64,   GPUM:0}),
                opt("ml.r6id.4xlarge",{GPU:0, CPU:16,  Memory:128,  GPUM:0}),
                opt("ml.r6id.8xlarge",{GPU:0, CPU:32,  Memory:256,  GPUM:0}),
                opt("ml.r6id.12xlarge",{GPU:0, CPU:48, Memory:384,  GPUM:0}),
                opt("ml.r6id.16xlarge",{GPU:0, CPU:64, Memory:512,  GPUM:0}),
                opt("ml.r6id.24xlarge",{GPU:0, CPU:96, Memory:768,  GPUM:0}),
                opt("ml.r6id.32xlarge",{GPU:0, CPU:128,Memory:1024, GPUM:0}),
                opt("ml.r5.large",    {GPU:0, CPU:2,   Memory:16,   GPUM:0}),
                opt("ml.r5.xlarge",   {GPU:0, CPU:4,   Memory:32,   GPUM:0}),
                opt("ml.r5.2xlarge",  {GPU:0, CPU:8,   Memory:64,   GPUM:0}),
                opt("ml.r5.4xlarge",  {GPU:0, CPU:16,  Memory:128,  GPUM:0}),
                opt("ml.r5.8xlarge",  {GPU:0, CPU:32,  Memory:256,  GPUM:0}),
                opt("ml.r5.12xlarge", {GPU:0, CPU:48,  Memory:384,  GPUM:0}),
                opt("ml.r5.16xlarge", {GPU:0, CPU:64,  Memory:512,  GPUM:0}),
                opt("ml.r5.24xlarge", {GPU:0, CPU:96,  Memory:768,  GPUM:0}),
            ]
        },
        {
            label: "Accelerated Computing",
            options: [
                opt("ml.p2.xlarge",    {GPU:1,  CPU:4,   Memory:61,   GPUM:12}),
                opt("ml.p2.8xlarge",   {GPU:8,  CPU:32,  Memory:488,  GPUM:96}),
                opt("ml.p2.16xlarge",  {GPU:16, CPU:64,  Memory:732,  GPUM:192}),
                opt("ml.p3.2xlarge",   {GPU:1,  CPU:8,   Memory:61,   GPUM:16}, true),
                opt("ml.p3.8xlarge",   {GPU:4,  CPU:32,  Memory:244,  GPUM:64}, true),
                opt("ml.p3.16xlarge",  {GPU:8,  CPU:64,  Memory:488,  GPUM:128}, true),
                opt("ml.p4d.24xlarge", {GPU:8,  CPU:96,  Memory:1152, GPUM:320}),
                opt("ml.p4de.24xlarge",{GPU:8,  CPU:96,  Memory:1152, GPUM:640}),
                opt("ml.g4dn.xlarge",  {GPU:1,  CPU:4,   Memory:16,   GPUM:16}),
                opt("ml.g4dn.2xlarge", {GPU:1,  CPU:8,   Memory:32,   GPUM:16}),
                opt("ml.g4dn.4xlarge", {GPU:1,  CPU:16,  Memory:64,   GPUM:16}),
                opt("ml.g4dn.8xlarge", {GPU:1,  CPU:32,  Memory:128,  GPUM:16}),
                opt("ml.g4dn.12xlarge",{GPU:4,  CPU:48,  Memory:192,  GPUM:64}),
                opt("ml.g4dn.16xlarge",{GPU:1,  CPU:64,  Memory:256,  GPUM:16}),
                opt("ml.g5.xlarge",    {GPU:1,  CPU:4,   Memory:16,   GPUM:24}),
                opt("ml.g5.2xlarge",   {GPU:1,  CPU:8,   Memory:32,   GPUM:24}),
                opt("ml.g5.4xlarge",   {GPU:1,  CPU:16,  Memory:64,   GPUM:24}),
                opt("ml.g5.8xlarge",   {GPU:1,  CPU:32,  Memory:128,  GPUM:24}),
                opt("ml.g5.12xlarge",  {GPU:4,  CPU:48,  Memory:192,  GPUM:96}),
                opt("ml.g5.16xlarge",  {GPU:1,  CPU:64,  Memory:256,  GPUM:24}),
                opt("ml.g5.24xlarge",  {GPU:4,  CPU:96,  Memory:384,  GPUM:96}),
                opt("ml.g5.48xlarge",  {GPU:8,  CPU:192, Memory:768,  GPUM:192}),
            ]
        }
    ]
};

function displayMessage(details: Details) {
    const {GPU: gpu, CPU: cpu, Memory: mem, GPUM: gpum} = details;
    if (gpu === 0 && gpum === 0)
        return `${cpu} vCPUs and ${mem} GiB of Memory.`;
    else if (gpu > 0 && gpum > 0)
        return `${cpu} vCPUs, ${mem} GiB of Memory, ${gpu} GPUs and ${gpum} GiB of GPU Memory.`;
    else if (gpu > 0)
        return `${cpu} vCPUs, ${mem} GiB of Memory and ${gpu} GPUs.`;
    else
        return `${cpu} vCPUs, ${mem} GiB of Memory and ${gpum} GiB of GPU Memory.`;
}

export function instance_additional_gpu_info(instance_type: string) {
    for (const group of instanceTypes.type_groups) {
        for (const option of group.options) {
            if (option.id === instance_type) {
                return displayMessage(option.details);
            }
        }
    }
}
